import $ from 'jquery';
import _ from 'underscore';
import Promise from 'bluebird';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { BudgetLandScapeTable } from '@bingads-webui-campaign/recommendation-inline-budget-view';
import { budgetLandscapeLegacyStrings } from './budget-landscape-legacy-strings';

const getBudgetLandscapeUrl = ({
  adInsightApi,
  customerId,
  accountId,
  campaignId,
  isSharedBudget,
  budgetId,
}) => {
  if (isSharedBudget) {
    return `${adInsightApi}AdInsight/V2/Customers(${customerId})/Accounts(${accountId})/Recommendation.GetSharedBudgetLandscape(SharedBudgetId=${budgetId})`;
  }

  return `${adInsightApi}AdInsight/V2/Customers(${customerId})/Accounts(${accountId})/Campaigns(${campaignId})/Opportunity.GetBudgetLandscape`;
};

const fetchBudgetLandscape = ({
  serverContext,
  scope,
  isSharedBudget,
  budgetId,
}) => new Promise((resolve, reject) => {
  const {
    Token,
    ServicesEndpoints,
  } = serverContext;
  const {
    AdInsightAPI: adInsightApi,
  } = ServicesEndpoints;
  const { aid: accountId, cid: customerId, campaignId } = scope.values;
  const url = getBudgetLandscapeUrl({
    adInsightApi,
    customerId,
    accountId,
    campaignId,
    isSharedBudget,
    budgetId,
  });

  return $.ajax({
    url,
    type: 'GET',
    headers: {
      Authorization: `CCMTSmallToken ${Token}`,
    },
  }).then(results => resolve(results), reject);
});

export const getBudgetLandscapeTableView = ({
  serverContext,
  scope,
  currentBudgetAmount,
  isSharedBudget,
  budgetId,
  i18n,
  activityLogger,
}) => fetchBudgetLandscape({
  serverContext,
  scope,
  isSharedBudget,
  budgetId,
}).then((res) => {
  const rawData = _.chain(res).result('value').first().value();
  const {
    BudgetRange,
    CurrentAccount,
  } = serverContext;
  let tableView = null;

  const budgetRange = {
    CeilingValue: BudgetRange.DailyRange.CeilingValue,
    FloorValue: BudgetRange.DailyRange.FloorValue,
  };

  if (rawData) {
    tableView = new BudgetLandScapeTable({
      opportunityData: rawData,
      i18n: buildLegacyI18n(i18n, budgetLandscapeLegacyStrings, {
        currency: CurrentAccount.CurrencyCode,
        timeZone: CurrentAccount.TimeZone,
      }),
      conversionSummaryStatus: rawData.ConversionStatus,
      budgetRange,
      currentBudget: currentBudgetAmount,
      fromBudgetColumn: true,
      fromCampaignTab: true,
      isSharedBudget,
    });

    tableView.render();

    const { campaignId } = scope.values;

    activityLogger.trace(
      {
        campaignId,
        budgetId,
        component: 'campaign summary bar fetch budget landscape',
        opportunityId: rawData.OpportunityId,
        opportunityData: rawData,
        currency: tableView.i18n.currency,
        ActionName: 'View',
        Channel: 'ClientName:bingadsweb[SummaryBarEditing]',
      },
      'AdInsight.Budget'
    );
  }

  return tableView;
});
